import "../../App.css";
import React, { Suspense, lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Loading from "../../Component/Loading";
import {
  AcademicHeadEmpSidebarData,
  AcademicHeadSidebarData,
} from "../../Module/academicHeadSidebarData";
import { useSelector } from "react-redux";
import { Logout, setInitialState } from "../../Action/authAction";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";
import UserDataSearch from "../CXOPanel/userDataSearch";
import GetInfluencer from "../CXOPanel/influencer/getInfluencer";
import ScholarshipExamResult from "../SalesUpsellingPanel/scholarshipExamResult";
const DoubtSolve = React.lazy(() => import("./doubtSolveReview"));
// const LeadCount = React.lazy(() => import("./leadCount"));
const LeadDashboard = React.lazy(
  () => import("../CategoryPanel/leadDashboard"),
);
const LeadCount = React.lazy(() => import("../CategoryPanel/leadCount"));
const LeadAnalysis = React.lazy(() => import("../CategoryPanel/leadAnalysis"));
const TargetStatus = React.lazy(() => import("../CategoryPanel/targetStatus"));
const TeacherTaskPlan = React.lazy(() => import("./teacherTaskPlan"));
const ResultCompilation = React.lazy(() => import("./resultCompilation"));
// same API as the old Finance pages, built with the custom components
const DatewiseCount = React.lazy(() => import("../CXOPanel/cxoDateWiseCount"));
const BatchWiseCount = React.lazy(
  () => import("../CXOPanel/cxoBatchWiseCount"),
);
const TeacherTaskPlanPending = React.lazy(
  () => import("./teacherTaskPlanPending"),
);
const TeacherTaskPlanComplete = React.lazy(
  () => import("./teacherTaskPlanCompleted"),
);
const TeacherTaskPlanNotComplete = React.lazy(
  () => import("./teacherTaskPlanNotCompleted"),
);
const ExamWiseRevenue = React.lazy(() => import("./examWiseAnalysis"));
const ExamDataWithoutGST = React.lazy(() => import("./examDataWithoutGST"));
const StudentResult = lazy(() => import("../CategoryPanel/studentResult"));
const AddResult = lazy(() => import("../CategoryPanel/resultCompilation"));
const MovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const TeamLeadsOverview = React.lazy(
  () => import("../CXOPanel/teamLeadsOverview"),
);
const CounsellorLeadOverview = React.lazy(
  () => import("../CXOPanel/counsellorLeadOverview"),
);
const LeadAssignedDateAnalysis = React.lazy(
  () => import("../CXOPanel/leadAssignedDateAnalysis"),
);
const LeadAssignedStatusOverview = React.lazy(
  () => import("../CXOPanel/leadAssignedStatusOverview"),
);
const CompleteLeadDetail = React.lazy(
  () => import("../CXOPanel/completeLeadDetail"),
);
const SourceWiseDataAnalysis = lazy(() => import("./sourceWiseDataAnalysis"));
const CategoryWiseAnalysis = lazy(
  () => import("../CXOPanel/categoryWiseAnalysis"),
);
const StudentDetails = lazy(
  () => import("./categoryWiseAnalysis/studentDetails"),
);
const SourceWiseLeadAnalysis = lazy(
  () => import("./categoryWiseAnalysis/sourceWiseLeadAnalysis"),
);
const UserActivityTracker = lazy(() => import("./userActivityTracker"));
const UserActivityDetails = lazy(() => import("./userActivityDetails"));
const ExamAnalytics = lazy(
  () => import("../CXOPanel/examAnalytics/examAnalytics"),
);
const LeadSummary = lazy(() => import("./leadSummary"));
const SundayTestAnalysisDashboard = React.lazy(
  () =>
    import("../TeacherPanel/SundayTestAnalysis/sundayTestAnalysisDashboard"),
);
const PaymentWiseRevenue = React.lazy(() => import("./paymentWiseRevenue"));
const PaidAds = React.lazy(() => import("../PaidAdsPanel/paidAds"));
const PaidAdsAnalysis = React.lazy(
  () => import("../PaidAdsPanel/paidAdsAnalysis"),
);
const EditDeleteTeacherTask = lazy(
  () => import("../CategoryPanel/editDeleteTeacherTask"),
);
const FreePageAnalysis = lazy(
  () => import("../CXOPanel/freePageAnalysis"),
);
// Daily Meeting tab
const TeacherPerformance = lazy(
  () => import("../CategoryPanel/teacherPerformanceCategory"),
);
const OffTopicPerformance = lazy(
  () => import("../CategoryPanel/offTopicPerformance"),
);
const AddLiveCompetitorAnalysis = lazy(
  () =>
    import("../CategoryPanel/CompetitorAnalysis/LiveAnalysis/addLiveCompetitorAnalysis"),
);
const AddOffVideoCompetitorAnalysis = lazy(
  () =>
    import("../CategoryPanel/CompetitorAnalysis/OffVideoAnalysis/addOffVideoAnalysis"),
);
const InstaReels = lazy(() => import("../Common/DailyMeeting/instaReels"));
const DailyLeadAnalysis = lazy(
  () => import("../Common/DailyMeeting/dailyLeadAnalysis"),
);
const DailyRevenueAnalysis = lazy(
  () => import("../Common/DailyMeeting/dailyRevenueAnalysis"),
);
const UserActivityAnalysis = lazy(
  () => import("../Common/DailyMeeting/userActivityAnalysis"),
);
const DailyPaidAdsAnalysis = lazy(
  () => import("../Common/DailyMeeting/paidAdsAnalysis"),
);
function AcademicHeadDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (!(role === "HOD" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);

  return (
    <div className="AppBox">
      <Sidebar
        data={
          loginType === 2 ? AcademicHeadEmpSidebarData : AcademicHeadSidebarData
        }
      />
      <div className="dashboard">
        <Suspense
          fallback={
            <div className="border p-1">
              <Loading />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<LeadDashboard />} />
            <Route path="leadDashboard" element={<LeadDashboard />} />
            <Route path="LeadCount" element={<LeadCount />} />
            <Route path="leadAnalysis" element={<LeadAnalysis />} />
            <Route path="targetStatus" element={<TargetStatus />} />
            <Route path="teacherTaskPlan" element={<TeacherTaskPlan />} />
            <Route path="getInfluencer" element={<GetInfluencer />} />
            <Route
              path="teacherTaskPlanPending"
              element={<TeacherTaskPlanPending />}
            />
            <Route
              path="teacherTaskPlanComplete"
              element={<TeacherTaskPlanComplete />}
            />
            <Route
              path="teacherTaskPlanNotComplete"
              element={<TeacherTaskPlanNotComplete />}
            />
            <Route path="doubtsolvereview" element={<DoubtSolve />} />
            <Route path="resultCompilation" element={<ResultCompilation />} />
            <Route path="BatchwiseCount" element={<BatchWiseCount />} />
            <Route path="DatewiseCount" element={<DatewiseCount />} />
            <Route path="ExamWiseRevenue" element={<ExamWiseRevenue />} />
            <Route path="examDataWithoutGST" element={<ExamDataWithoutGST />} />
            <Route path="addResult" element={<AddResult />} />
            <Route path="studentResult" element={<StudentResult />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route
              path="editMovementsOfMeeting"
              element={<EditMovementsOfMeeting />}
            />
            <Route path="teamLeadsOverview" element={<TeamLeadsOverview />} />
            <Route
              path="counsellorLeadOverview"
              element={<CounsellorLeadOverview />}
            />
            <Route
              path="leadAssignedDateAnalysis"
              element={<LeadAssignedDateAnalysis />}
            />
            <Route
              path="leadAssignedStatusOverview"
              element={<LeadAssignedStatusOverview />}
            />
            <Route path="completeLeadDetail" element={<CompleteLeadDetail />} />

            <Route path="userDataSearch" element={<UserDataSearch />} />
            <Route
              path="sourceWiseDataAnalysis"
              element={<SourceWiseDataAnalysis />}
            />
            <Route
              path="categoryWiseAnalysis"
              element={<CategoryWiseAnalysis />}
            />
            <Route path="studentDetails" element={<StudentDetails />} />
            <Route
              path="sourceWiseLeadAnalysis"
              element={<SourceWiseLeadAnalysis />}
            />
            <Route
              path="userActivityTracker"
              element={<UserActivityTracker />}
            />
            <Route
              path="userActivityDetails"
              element={<UserActivityDetails />}
            />
            <Route
              path="ScholarshipExamResult"
              element={<ScholarshipExamResult />}
            />
            <Route path="examAnalytics" element={<ExamAnalytics />} />
            <Route path="leadSummary" element={<LeadSummary />} />
            <Route
              path="sundayTestAnalysisDashboard"
              element={<SundayTestAnalysisDashboard />}
            />
            <Route path="paymentWiseRevenue" element={<PaymentWiseRevenue />} />
            <Route path="paidAds" element={<PaidAds />} />
            <Route path="paidAdsAnalysis" element={<PaidAdsAnalysis />} />
            <Route
              path="editDeleteTeacherTask"
              element={<EditDeleteTeacherTask />}
            />
            <Route path="freePageAnalysis" element={<FreePageAnalysis />} />

            {/* Daily Meeting tab (datewisecount and leadAnalysis are routed above) */}
            <Route path="cxoBatchwiseCount" element={<BatchWiseCount />} />
            <Route
              path="teacherPerformanceCat"
              element={<TeacherPerformance />}
            />
            <Route
              path="offTopicPerformance"
              element={<OffTopicPerformance />}
            />
            <Route
              path="addLiveCompetitorAnalysis"
              element={<AddLiveCompetitorAnalysis />}
            />
            <Route
              path="addOffVideoCompetitorAnalysis"
              element={<AddOffVideoCompetitorAnalysis />}
            />
            <Route path="instaReels" element={<InstaReels />} />
            <Route path="dailyLeadAnalysis" element={<DailyLeadAnalysis />} />
            <Route
              path="dailyRevenueAnalysis"
              element={<DailyRevenueAnalysis />}
            />
            <Route
              path="userActivityAnalysis"
              element={<UserActivityAnalysis />}
            />
            <Route
              path="dailyPaidAdsAnalysis"
              element={<DailyPaidAdsAnalysis />}
            />
          </Routes>
        </Suspense>
      </div>
    </div>
  );
}

export default AcademicHeadDashboard;
